import {Translate} from "../../../../hooks/translate.hook";
import {ColumnsType} from "antd/lib/table/interface";
import {TableLineData} from "./split.modal.data";
import {displayPrice} from "../../../../models/prices/price.helper";
import Date from "../../../date/date";
import {SelectQty} from "../../create/steps/select-sku/select-qty/select-qty";

export const columnsFactory = (
        t: Translate,
        allowedQty: number,
        onSelect: (item: TableLineData, value: number) => void
    ): ColumnsType<TableLineData> => {
        return [
            {
                title: "Document",
                width: 150,
                dataIndex: "docNumber",
                key: "docNumber",
                render: (docNumber) => docNumber
            },
            {
                title: "Sales document",
                width: 150,
                dataIndex: "salesDocNumber",
                key: "salesDocNumber",
                render: (docNumber) => docNumber
            },
            {
                title: "Warehouse",
                width: 100,
                dataIndex: "warehouse",
                key: "warehouse",
                render: (warehouse) => warehouse.toUpperCase()
            },
            {
                title: "Dispatch date",
                dataIndex: "date",
                key: "date",
                render: (date) => <Date dateString={date} />
            },
            {
                title: "Price",
                dataIndex: "price",
                key: "price",
                render: (price) => displayPrice(price)
            },
            {
                title: "Qty",
                dataIndex: "qty",
                key: "qty",
            },
            {
                title: "Use Qty",
                width: 180,
                key: "useQty",
                render: (_, data) =>
                    <SelectQty
                        onSelect={val => onSelect(data, val)}
                        maxQty={Math.min(data.qty, allowedQty)}
                    />
            }
        ]
}